export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || "GTM-XXXXXXX"
export const PIXEL_ID = process.env.NEXT_PUBLIC_PIXEL_ID || ""

export const pageView = (url) => {
    window.dataLayer?.push({
        event: 'pageview',
        page: url,
    })
}